/**
 * Created by yuanlei on 2020/7/10.
 */
const isEmpty = function(val) {
  if (val == null || val == "" || typeof(val) == undefined) {
    return true;
  } else {
    return false;
  }
}
const isNullOrEmpty = function(val) {
  if (val == null || val == "" || typeof(val) == undefined) {
      return true;
  } else {
      return false;
  }
}

const tipMsg = function(msg,val,val1) {
  if (val == null || val == "" || typeof(val) == undefined) {
    return val1;
  } else {
    return val;
  }
}

const timeFormat = (value, format) => {
  if(!value) return ''
  let date = new Date(value);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let min = date.getMinutes();
  let s = date.getSeconds();
  let result = "";
  if (format == undefined) {
    result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
      h < 10 ? "0" + h : h
      }:${min < 10 ? "0" + min : min}`;
  }
  if (format == "yyyy-mm-dd") {
    result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
  }
  if (format == "yyyy-mm") {
    result = `${y}-${m < 10 ? "0" + m : m}`;
  }
  if (format == "mm-dd") {
    result = ` ${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
  }
  if (format == "hh:mm") {
    result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
  }
  if (format == "yyyy") {
    result = `${y}`;
  }
  return result;
};

const dataFormat = (value, format) => {
  if(!value) return ''
  let date = new Date(value);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let min = date.getMinutes();
  let s = date.getSeconds();
  let result = "";
  if (format == undefined) {
    result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
  }
  if (format == "yyyy-mm-dd") {
    result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
  }
  if (format == "yyyy-mm") {
    result = `${y}-${m < 10 ? "0" + m : m}`;
  }
  if (format == "mm-dd") {
    result = ` ${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
  }
  return result;
};


export {
  isEmpty,
  isNullOrEmpty,
  tipMsg,
  timeFormat
}



// WEBPACK FOOTER //
// ./src/filters/index.js